import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, } from "@mui/material";
import { ToastContext } from "../../contexts/toast-context";
import { AuthContext } from "../../contexts/auth-context.jsx";
import { deleteUser } from "../../api/user-api.js";
import { useMutation } from "@tanstack/react-query";
import { UserContext } from "../../contexts/user-context.jsx";

export const DeleteProfile = ({ open, onClose }) => {
  const { t } = useTranslation(["user", "validation", "common"]);
  const { showSuccess, showError } = useContext(ToastContext);

  const { user } = useContext(UserContext);
  const { logout } = useContext(AuthContext);

  const mutation = useMutation({
    mutationFn: () => {
      return deleteUser(user.id)
    },
    onSuccess: () => {
      showSuccess(t("successfulAction"));
      logout();
    },
    onError: (error) => {
      showError(error?.response?.data?.error_message ||
        t("genericError", { action: t("deleteProfile") }));
    }
  });

  return (
    <Dialog open={open} onClose={() => onClose()} maxWidth="sm" fullWidth>
      <DialogTitle>{t("deleteProfile")}</DialogTitle>
      <DialogContent>{t("deleteProfileContent")}</DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={mutation.isPending}>
          {t("cancel")}
        </Button>
        <Button onClick={mutation.mutate} disabled={mutation.isPending} color={"error"} autoFocus>
          {t("confirm")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
